import React from 'react';
import { Shield, Award, Video, DollarSign } from 'lucide-react';
import { mockTrustBadges } from '../mockData';

const iconMap = {
  Shield: Shield,
  Award: Award,
  Video: Video,
  DollarSign: DollarSign
};

const TrustBadges = () => {
  const gradients = [
    'from-[#0066FF] to-[#00A3FF]',
    'from-[#FF0099] to-[#FF66CC]',
    'from-[#0066FF] via-[#0099FF] to-[#FF0099]',
    'from-[#FF0099] via-[#CC0099] to-[#0066FF]'
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {mockTrustBadges.map((badge, index) => {
        const Icon = iconMap[badge.icon];
        return (
          <div
            key={badge.id}
            className="flex flex-col items-center text-center p-6 bg-white rounded-2xl border-2 border-gray-100 hover:border-[#0066FF] hover:shadow-xl transition-all duration-300 transform hover:scale-105 group"
          >
            <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${gradients[index]} flex items-center justify-center mb-4 shadow-lg group-hover:shadow-2xl transition-shadow duration-300`}>
              <Icon className="text-white" size={28} />
            </div>
            <h3 className="font-bold text-[#1A202C] mb-2 text-base">{badge.title}</h3>
            <p className="text-sm text-[#4A5568] leading-relaxed">{badge.description}</p>
          </div>
        );
      })}
    </div>
  );
};

export default TrustBadges;
